import type {
  GTMEventGlycerinDisplayLink,
  GTMEventGlycerinDisplayOverlay,
  GTMEventGlycerinLinkClick,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';

export const useInstallmentCalculatorTracking = () => {
  const dispatchTracking = useTracking();

  const label = 'Kredit-Promo';

  const trackGlycerinDisplayLink = () => {
    dispatchTracking<GTMEventGlycerinDisplayLink>({
      event: 'DisplayLink',
      DisplayLinkData: {
        category: 'Ratenelement',
        label,
        target: 'Overlay',
      },
    });
  };

  const trackGlycerinLinkClick = () => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category: 'Ratenrechner',
        label,
      },
    });
  };

  const trackDialogOpen = () => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: { category: 'Ratenrechner', label },
    });
  };

  return {
    trackGlycerinDisplayLink,
    trackGlycerinLinkClick,
    trackDialogOpen,
  };
};
